import { Fragment, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { CategoryPanel } from "./CategoryPanel";
import { Link, useNavigate } from "react-router-dom";
import { excludeMegaMenu } from "../../constants";
import { PAGES } from "../../routeConfig";
import { readCategoryCache, writeCategoryCache } from "../../utils/categoryCache";

export const ShopAllProducts = () => {
  const globalcontext = useContext(GlobalContext);
  const history = useNavigate();
  const [mainCategory, setMainCategory] = useState(null);
  useEffect(() => {
    axiosInstance
      .get("GetStaticData/GetCategoryList")
      .then((response) => {
        setMainCategory(
          response.data.sort((a, b) =>
            a.categoryName.localeCompare(b.categoryName, undefined, {
              sensitivity: "base",
            }),
          ),
        );
        window.categoryHoverFun();
        window.categoryClickFun();
      })
      .catch((error) => {
        return error.message;
      });
  }, []);
  useEffect(() => {
    getCategoryDataJson();
  }, []);

  const applyCategoryData = (data) => {
    if (!data) return;
    if (data.categoryMenu) {
      var refinedMenu = data.categoryMenu
        .filter((menu) => !excludeMegaMenu.includes(menu.categoryId))
        .sort((a, b) =>
          a.categoryName.localeCompare(b.categoryName, undefined, {
            sensitivity: "base",
          }),
        );

      globalcontext.setCategoryMenu(refinedMenu);
    }
    if (data.categoryJsonAll) globalcontext.setCategoryDataAll(data.categoryJsonAll);

    window.categoryHoverFun();
    window.categoryClickFun();
  };

  const getCategoryDataJson = async () => {
    const cached = readCategoryCache();
    if (cached) {
      applyCategoryData(cached);
      return cached;
    }

    let response = await axiosInstance.get("Category/GetCategoryData");
    if (response.data) {
      applyCategoryData(response.data);
      writeCategoryCache(response.data);
    }
    return response.data;
  };
  return (
    <Fragment>
      <div
        className="modal category-modal fade"
        data-backdrop="true"
        data-keyboard="false"
        id="shop-allProducts"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog allproducts-dialog modal-dialog-slideout">
          <div className="modal-content allproducts-content">
            <div className="modal-body allproducts-body">
              {/*  Category menus */}
              <div className="allproducts-header">
                <a className="allproducts-close d-none d-lg-block" data-bs-dismiss="modal" aria-label="Close">
                  <i className="fa-solid fa-xmark d-none d-lg-block" />
                  <p className="d-block d-lg-none">
                    <i className="fa-solid fa-house" /> Back to Home
                  </p>
                </a>
                <div className="all-products">
                  <div className="shop-department d-block d-lg-none mt-0">
                    <p>Quick Links</p>
                  </div>
                  {/* No keys here on purpose. These are static JSX siblings, not a mapped array -
                      React reconciles them by position and ignores keys entirely. The only thing
                      the hand-numbered keys ever did was let two of them collide on key={4}, which
                      is what produced the duplicate-key warning. */}
                  <ul className="allProducts-slider">
                    <li>
                      <a href="#." className="active">
                        Browse Category
                      </a>
                    </li>
                    <li>
                      <Link to={PAGES.NEWPRODUCTS_CT}>New Products</Link>
                    </li>
                    <li>
                      <Link to={PAGES.CLEARANCE_CT}>Clearance Products</Link>
                    </li>
                    <li>
                      <Link to={PAGES.BRAND}>Browse by Brands</Link>
                    </li>
                    <li>
                      <Link to={PAGES.BRANDS_CT}> Compatible Brands</Link>
                    </li>
                    <li>
                      <Link to={PAGES.ONLINE_CATALOGUE}>Catalogue eBooks</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="shop-department d-block d-lg-none">
                <p>Shop by Category</p>
              </div>
              <div className="all-prodcuts-menus">
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="category-tab"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="categ-menus">
                      <ul className="nav nav-tabs" id="myTabs">
                        {mainCategory &&
                          mainCategory.map((row, index) => (
                            <li className="nav-item" data-item={index} key={index}>
                              <a
                                className={"category-link " + (index === 0 && "active")}
                                data-bs-toggle="tab"
                                href={"#" + row.categoryId}
                                onClick={() => history(row.categoryPath)}
                              >
                                <p>
                                  <img src={row.categoryImage} alt="av-tv" />
                                  {row.categoryName}
                                </p>
                                <i className="fa-solid fa-chevron-right" />
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                    {/* tab content */}
                    <div className="tab-content categ-menus-content">
                      {globalcontext.CategoryMenu &&
                        globalcontext.CategoryMenu.map((row, index) => (
                          <CategoryPanel key={row.categoryId ?? index} data={row} index={index} />
                        ))}
                    </div>
                    {/* tab content */}
                  </div>
                </div>
              </div>
              {/*  Category menus */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
